import contract_type_img_1 from "../../assets/images/contract-type/contract-type-1.jpg";
import contract_type_img_2 from "../../assets/images/contract-type/contract-type-2.jpg";
import contract_type_img_3 from "../../assets/images/contract-type/contract-type-3.jpg";
import contract_type_img_4 from "../../assets/images/contract-type/contract-type-4.jpg";
import contract_type_img_5 from "../../assets/images/contract-type/contract-type-5.jpg";
import contract_type_img_6 from "../../assets/images/contract-type/contract-type-6.jpg";
import contract_type_img_7 from "../../assets/images/contract-type/contract-type-7.jpg";
import contract_type_img_8 from "../../assets/images/contract-type/contract-type-8.jpg";
import contract_type_img_9 from "../../assets/images/contract-type/contract-type-9.jpg";
import contract_type_img_10 from "../../assets/images/contract-type/contract-type-10.jpg";
import contract_type_img_11 from "../../assets/images/contract-type/contract-type-11.jpg";
import contract_type_img_12 from "../../assets/images/contract-type/contract-type-12.jpg";
import contract_type_img_13 from "../../assets/images/contract-type/contract-type-13.jpg";
import contract_type_img_14 from "../../assets/images/contract-type/contract-type-14.jpg";
import contract_type_img_15 from "../../assets/images/contract-type/contract-type-15.jpg";
import contract_type_img_16 from "../../assets/images/contract-type/contract-type-16.jpg";

// For '所有合約類型'
export const contractTypeData = [
    {
        id: 1,
        src: contract_type_img_1,
        contractType: "保密協議(NDA)",
        description: "適用於任何可能揭露機密資訊的合作關係。",
        url: "NDA"
    },
    {
        id: 2,
        src: contract_type_img_2,
        contractType: "勞動契約",
        description: "適用於雇主僱用勞工（員工）。",
        url: "labor-contract"
    },
    {
        id: 3,
        src: contract_type_img_3,
        contractType: "承攬契約",
        description: "適用於所有「外包工作」的通用型契約，例如：空間設計、室內裝修、軟體開發、攝影、翻譯、家庭代工、廣告活動企劃等。"
    },
    {
        id: 4,
        src: contract_type_img_4,
        contractType: "汽車買賣合約",
        description: "適用於新車或中古車買賣。"
    },
    {
        id: 5,
        src: contract_type_img_5,
        contractType: "房屋租賃契約",
        description: "適用於出租、承租房屋。"
    },
    {
        id: 6,
        src: contract_type_img_6,
        contractType: "頂讓合約",
        description: "適用於店面頂讓。"
    },
    {
        id: 7,
        src: contract_type_img_7,
        contractType: "合夥契約",
        description: "適用於合夥人出資共同成立「合夥事業」（不包含成立「公司」）。"
    },
    {
        id: 8,
        src: contract_type_img_8,
        contractType: "合作協議書 (團購)",
        description: "適用於品牌商與團購主合作。"
    },
    {
        id: 9,
        src: contract_type_img_9,
        contractType: "投資協議書",
        description: "適用於投資人投資已經設立的「股份有限公司」。"
    },
    {
        id: 10,
        src: contract_type_img_10,
        contractType: "借貸契約",
        description: "適用於借貸金錢、房屋、車輛或其他物品。"
    },
    {
        id: 11,
        src: contract_type_img_11,
        contractType: "採購合約",
        description: "適用於向供應商採購貨品。"
    },
    {
        id: 12,
        src: contract_type_img_12,
        contractType: "代理契約",
        description: "適用於品牌請代理商代銷商品。"
    },
    {
        id: 13,
        src: contract_type_img_13,
        contractType: "經銷契約",
        description: "適用於品牌請經銷商經銷商品。"
    },
    {
        id: 14,
        src: contract_type_img_14,
        contractType: "IP 授權書",
        description: "適用於各式需要 IP 授權的情境（如：聯名商品）。"
    },
    {
        id: 15,
        src: contract_type_img_15,
        contractType: "設計接案合約",
        description: "適用於設計接案。"
    },
    {
        id: 16,
        src: contract_type_img_16,
        contractType: "股東協議書（股份有限公司）",
        description: "適用於原始股東出資共同成立「股份有限公司」（不包含成立「合夥」或「有限公司」）。"
    },
];



